import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppStateService, DateService } from '@app/core/services';
import { untilDestroyed } from '@app/core/helpers/until-destroyed';
import { UserInfo } from '@app/data/models';

@Component({
    selector: 'app-left-side-menu',
    templateUrl: './left-side-menu.component.html',
    styleUrls: ['./left-side-menu.component.scss'],
    providers: [DateService],
    standalone: false,
})
export class LeftSideMenuComponent implements OnInit {
    userData: UserInfo = null;
    hasAdminRights = false;
    canAccessSuperadminSection = false;

    trialDays$: Observable<string>;

    private router = inject(Router);
    private appStateService = inject(AppStateService);
    private untilDestroy = untilDestroyed();

    ngOnInit() {
        this.getUserData();
        this.trialDays$ = this.appStateService.trialDays$;
    }

    onSignout() {
        this.appStateService.logoutUser();
    }

    toggleAdminPanelDialog(section) {
        this.router.navigate([], { queryParams: { modal: 'admin_panel', section: section } });
    }

    onToggleProfile() {
        this.router.navigate(['/app/profile']);
    }

    private getUserData() {
        this.appStateService.userInfo$.pipe(this.untilDestroy()).subscribe((userInfo) => {
            this.userData = userInfo;
            this.hasAdminRights = this.userData?.user.is_silo_admin;
            this.canAccessSuperadminSection = this.userData?.user.is_superuser;
        });
    }

    get adminOrSuperAdmin() {
        return this.hasAdminRights || this.canAccessSuperadminSection;
    }
}
